export default __webpack_public_path__ + "static/clutch-fa29d5b646487bb87827728771fc2696.webp";